import { Action } from 'redux'
import UserActions, { SetUserAction } from './actions'
import UserState, { getDefaultUserState } from './UserState'

export const reducer = (state: UserState = getDefaultUserState(), action: Action) => {
    switch(action.type) {
        case UserActions.SET_USER: {
            const setUserAction = action as SetUserAction
            return {
                displayName: setUserAction.user.displayName,
                username: setUserAction.user.username,
                roles: setUserAction.user.roles
            }
        }
        case UserActions.CLEAR_USER:
            return getDefaultUserState()
        default:
            return state
    }
}
